import { Immutable } from "immer";
import React from "react";

import { reverse } from "@reactivated";

import { ShipmentSummary } from "../ShipmentSummary";
import { TrackOrderSummaryHeader } from "../TrackOrderSummaryHeader";
import {
    FreightDeliverySteps,
    OrderPipelineConfig,
    SmallPackageDeliverySteps,
    TRSDeliverySteps,
    UnifiedOrderLookupOrder,
} from "../types";
import { getClosestStep, getUnifiedEvents } from "../utils";

import styles from "./index.module.scss";

export const TrackOrderSummary = (
    props: Immutable<{
        order: UnifiedOrderLookupOrder;
        config: OrderPipelineConfig | null;
        order_number_token: string;
        war_link: string;
    }>,
): React.JSX.Element => {
    const config = props.config;
    if (!config) {
        return <></>;
    }

    return (
        <section className={styles.container}>
            <TrackOrderSummaryHeader order={props.order} />

            {/* Render each shipment */}
            {props.order.shipments.map((shipment, i) => {
                const closestStep = getClosestStep(
                    shipment.events,
                    props.order.source,
                );
                let deliverySteps:
                    | Immutable<TRSDeliverySteps>
                    | Immutable<FreightDeliverySteps>
                    | Immutable<SmallPackageDeliverySteps>
                    | null = null;
                if (props.order.source === "TRS") {
                    deliverySteps = config.trs_delivery_steps || null;
                } else if (
                    shipment.has_small_package &&
                    !shipment.has_freight
                ) {
                    deliverySteps = config.small_package_delivery_steps || null;
                } else {
                    deliverySteps = config.freight_delivery_steps || null;
                }
                const unified_events = getUnifiedEvents(
                    props.order,
                    shipment,
                    deliverySteps,
                    closestStep,
                    true,
                );
                let trackShipmentURL = reverse(
                    "customer:unified-order-shipment-status",
                    {
                        order_number_token: props.order_number_token,
                        tracking_number:
                            shipment.last_mile_tracking_number ?? "",
                    },
                );
                if (shipment.has_small_package && !shipment.has_freight) {
                    trackShipmentURL = shipment.tracking_url ?? "";
                }

                return (
                    <ShipmentSummary
                        key={i}
                        shipment={shipment}
                        orderSource={props.order.source}
                        closestStep={closestStep}
                        unifiedEvents={unified_events}
                        trackShipmentUrl={trackShipmentURL}
                        warLink={props.war_link}
                    />
                );
            })}
        </section>
    );
};
